import React, { useMemo } from 'react';

import { Button } from '@tmap/mmm-style-guide/src/Button';
import { Check, MailOutline } from '@tmap/mmm-style-guide/src/Icon';
import { styled } from '@tmap/mmm-style-guide/src/styled';

const ClaimButton = styled(Button)(({ theme }) => ({
  '& .Mui-disabled': {
    color: theme.palette.text.primary,
  },
}));

function ExternalApplyButton(props) {
  const { incentive, handleClick, requested } = props;
  const {
    claimText, claimOff, claimIcon,
  } = useMemo(() => (
    requested ? {
      claimText: 'Application Requested',
      claimOff: true,
      statusHelperText: `We've passed your interest along to ${incentive.locationText}, and you can expect an email shortly.`,
      claimIcon: <Check />,
    } : {
      claimText: 'Request Application',
      statusHelperText: `We'll help you get in touch with ${incentive.locationText}'s incentive program.`,
      claimIcon: <MailOutline />,
    }
  ), [requested, incentive.locationText]);

  return (
    <ClaimButton
      variant='contained'
      color='inverted'
      size='large'
      fullWidth
      disabled={claimOff}
      endIcon={claimIcon}
      onClick={handleClick}
    >
      {claimText}
    </ClaimButton>
  );
}

export default ExternalApplyButton;
